import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F1125SchAService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: GET request for loading form data (following F965B pattern)
  loadF1125SchAData(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    // Use the correct endpoint for loading data
    const url = `${baseUrl}/loadPivotFormJson`;

    // Merge params with global and filter parameters
    let requestParams = _.merge({}, globalService?.globalParams || {}, filterParams, params);

    // Build query string for GET request
    const queryParams = new URLSearchParams();
    Object.keys(requestParams).forEach(key => {
      if (requestParams[key] !== null && requestParams[key] !== undefined) {
        queryParams.set(key, requestParams[key].toString());
      }
    });

    const urlWithParams = `${url}?${queryParams.toString()}`;

    return this.http.get<any>(urlWithParams);
  }

  // 🚀 CRITICAL: Accept filterParams and rowData parameters (SuperPrompt V6)
  saveF1125SchAForm(
    baseUrl: string,
    formData: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // 🚀 CRITICAL: Use correct URL construction (jmz70s action code from AngularJS)
    const url = `${baseUrl}/saveJsonObject?action_code=jmz70s`;

    // Get trans_type_key from first form data item (like AngularJS)
    const trans_type_key = formData[0]?.editrows?.[0]?.[0]?.trans_type_key;

    // 🚀 CRITICAL: Build payload EXACTLY like original AngularJS
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    // 🔴 CRITICAL: Use AngularJS field names jsonObj and jsonSettings (NOT clob_data/clob_settings)
    params = _.extend({
      jsonObj: JSON.stringify(formData)
    }, params);

    // Add settings object similar to AngularJS save1065Page1 method  
    const settingsObj = {
      "tax_year": rowData.TAX_YEAR,
      "scenario": rowData.SCENARIO_KEY,
      "jcd_key": rowData.JCD_KEY, 
      "combination_key": rowData.COMBINATION_KEY, 
      "trans_type_key": trans_type_key
    };

    params = _.extend({
      jsonSettings: JSON.stringify(settingsObj)
    }, params);

    // Add process name and other required fields
    params.process_name = "F1125_SCH_A_SAVE";
    params.combination_key = rowData.COMBINATION_KEY;
    
    if (trans_type_key) {
      params.trans_type_key = trans_type_key;
    }

    // 🔴 CRITICAL: Add missing required parameters from AngularJS payload
    params.scenarioCode = rowData.SCENARIO_CODE || filterParams.scenarioCode || filterParams.scenario_code || "RAF"; // Default from AngularJS
    params.is_issue_key_enabled = "N"; // Always N from AngularJS payload

    // 🚀 CRITICAL: Include checkLockedbj from rowData (NOT hardcoded) - match AngularJS structure exactly
    const checkLockedbj = [{
      "leid": rowData.LEID || rowData.SOURCE_LEID,
      "consol_group_key": String(rowData.CONSOL_GROUP_KEY || "1"), // This "1" is same as in AngularJS payload
      "combination_key": String(rowData.COMBINATION_KEY),
      "scenario_key": parseInt(filterParams.scenario || rowData.SCENARIO_KEY) // Remove 74 fallback - use real data
    }];

    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT application/json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}


